import { PartyType } from './../../../models/consultation/cash-sale.model';
import { Injectable } from '@angular/core';
import { CashSaleModel } from '../../../models/consultation/cash-sale.model';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { PriceUrl } from '../../../shared/urls/price.url';
import { BaseService } from '../../../shared/services/base.service';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { InvoiceUrl } from '../../../shared/urls/invoice.url';
import { Utility } from '../../../common/utility';

@Injectable()
export class CashSaleService {
    constructor(public baseService: BaseService) {
    }

    getCashSalePatientData() {
        const url = PatientUrl.GET_CASH_SALE_ACCOUNT;
        return this.baseService.getData(url, null);
    }
    getInvoice(invoiceId) {
        let url = '';
        url = Utility.stringFormat(InvoiceUrl.GET_INVOICE, [invoiceId]);
        return this.baseService.getData(url, null);
    }
    addNoteToInvoice(invoiceId, note) {
        const url = InvoiceUrl.ADD_NOTE_TO_INVOICE;
        return this.baseService.postData(url, { id: invoiceId, note: note });
    }
    saveInvoiceInfo(consultationId, data) {
        const url = Utility.stringFormat(InvoiceUrl.UPDATE_INVOICE_INFORMATION, [consultationId]);
        return this.baseService.postData(url, data);
    }
    getPatientInvoiceData(consultationId, isFromHistory, invoiceId) {
        let url = '';
        if (invoiceId) {
            url = Utility.stringFormat(InvoiceUrl.GET_ACCONT_PAYMENT_INVOICE_CASH_SALE, [invoiceId]);
        } else {
            if (consultationId && !isFromHistory) {
                url = Utility.stringFormat(InvoiceUrl.GET_CONSULTATION_CASH_SALE, [consultationId]);
            } else {
                url = InvoiceUrl.GET_CASH_SALE;
                return this.baseService.getData(url, { consultationId: consultationId });
            }
        }
        return this.baseService.getData(url);
    }

    saveCashSale(invoiceId, data, cashSaleInfo) {
        let url = '';
        if (invoiceId) {
            url = Utility.stringFormat(InvoiceUrl.UPDATE_CONSULTATION_INVOICE, [invoiceId]);
            return this.baseService.update(url, data);
        } else {
            data.partyTypeId = cashSaleInfo.partyTypeId;
            data.groupId = cashSaleInfo.groupId;
            data.orderNo = cashSaleInfo.orderNo;
            data.invoiceDate = cashSaleInfo.invoiceDate;
            url = Utility.stringFormat(InvoiceUrl.UPDATE_CONSULTATION_INVOICE, ['']);
            return this.baseService.postData(url, data);
        }
    }
    removeItem(invoiceId, itemId) {
        if (invoiceId) {
            const url = Utility.stringFormat(InvoiceUrl.GET_INVOICE_ITEM, [invoiceId, itemId]);
            return this.baseService.delete(url);
        }
    }
    getDiscountList() {
        return this.baseService.getAll(OrganizationUrl.ORGANIZATION_Discounts);
    }

    getPartyList() {
        const url = PatientUrl.GET_PARTY_TYPE;
        return this.baseService.getData(url);
    }

    getOrganization() {
        return this.baseService.getData(OrganizationUrl.ORGANIZATION_DROP_DOWN_LIST, { isShowAll: true });
    }

    getInvoiceOrganization(isEdit) {
      return this.baseService.getData(OrganizationUrl.ORGANIZATION_DROP_DOWN_LIST, { isShowAll: isEdit });
    }

    getConsultationFeeData() {
        const url = PriceUrl.GET_CENTRE_CONSULTATION_FEE;
        return this.baseService.getData(url);
    }

    updateAccountPaymentInvoiceInfor(data) {
        const url = InvoiceUrl.UPDATE_ACCONT_PAYMENT_INVOICE_INFORMATION;
        return this.baseService.postData(url, data);
    }
    sendInvoice(invoiceNumber, email, currency) {
        const url = InvoiceUrl.EMAIL_INVOICE;
        return this.baseService.postData(url, { invoiceNumber: invoiceNumber, currencyCode: currency, emailTo: email });
    }
}


/* const discountList = [
    {
        id: '0',
        name: 'Standard',
        value: 1
    },
    {
        id: '1',
        name: '10%',
        value: 0.9
    },
    {
        id: '2',
        name: '12.5%',
        value: 0.875
    },
    {
        id: '3',
        name: '15%',
        value: 0.85
    },
    {
        id: '4',
        name: '20%',
        value: 0.8
    },
    {
        id: '5',
        name: '30%',
        value: 0.7
    },
    {
        id: '6',
        name: '100%',
        value: 0
    }
]; */

/*
export const CashSaleList: CashSaleModel[] = [
    {
        id: "1", item: "Dilph", status: "Adminstered", quantity: "2", discountId: "0", tax: "0.00$", price: "$20.00"
    },
    {
        id: "2", item: "B12 & Folate", status: "Ordered", quantity: "3", discountId: "1", tax: "0.00$", price: "$30.00"
    }
]; */


/* const invoiceInfo = {
    id: 1,
    invoiceREF: '10013HC',
    defaultCurrencyCode: 'EUR', // default currency of centre
    currencyCode: 'GBP',    // currency of invoice
    partyTypeId: '0',
    groupId: '',
    orderNo: '',
    feeId: '',
    isNextVaccination: false, // patient is back to adminster vaccine, not charge fee for consultation
    currencyRate: [
        {
            code: "EUR",
            symbol: "€",
            symbolPosition: "L",
            rate: 1
        },
        {
            code: "GBP",
            symbol: "£",
            symbolPosition: "R",
            rate: 2.1545
        },
        {
            code: "ZAR",
            symbol: "R",
            symbolPosition: "L",
            rate: 3
        }
    ],
    invoiceDetails: [
        {
            id: "1",
            item: "Dilph",
            status: 1,
            invoiceNum: "",
            quantity: 2,
            discountId: "43322c9b-2c50-4e84-8531-36bbcd420fa7",
            tax: 1.00, // base on defaultCurrencyId
            price: 20.00 // base on defaultCurrencyId
        },
        {
            id: "2",
            item: "B12 & Folate",
            status: 5,
            invoiceNum: "INV001",
            quantity: 3,
            discountId: "e7f46443-8eb9-4bf6-8705-ec539dfed13d",
            tax: 0.00,
            price: 0.00
        },
        {
            id: "2",
            item: "B12 & Folate",
            status: 3,
            invoiceNum: "INV001",
            quantity: 3,
            discountId: "e7f46443-8eb9-4bf6-8705-ec539dfed13d",
            tax: 0.50,
            price: 30.00
        }
    ]
};

const consultationFee = [
    {
        id: '0',
        name: ' fee',
        value: 1
    },
    {
        id: '1',
        name: ' name',
        value: 2
    },
    {
        id: '2',
        name: ' name',
        value: 3
    }, {
        id: '3',
        name: 'name',
        value: 4
    }
]; */



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/cash-sale.service.ts